import fetchMyHomeLayouts from './fetchMyHomeLayouts'

export default function * fetchView () {
  yield fetchMyHomeLayouts()
}
